import React from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { Close, Save } from "@mui/icons-material";
import ActionButton, { ConditionalOutlinedButton } from "../../../components/commonComponents/Buttons/ActionButton";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import { StyledMainBox, StyledStack } from "../../../components/commonComponents/StyledComponents/styled";

const AccessSelection = ({
  open,
  title,
  description,
  options,
  initialSelection,
  showCancel,
  onCancel,
  onEnter,
}) => {
  const [selectedOption, setSelectedOption] = React.useState(typeof initialSelection !== "undefined" ? initialSelection : "");
  const selectionOptions = typeof options !== "undefined" ? options : [];

  React.useEffect(() => {
    setSelectedOption(typeof initialSelection !== "undefined" ? initialSelection : "");
  }, [initialSelection, open]);

  return (
    <Dialog
      disableEscapeKeyDown={true}
      open={open}
      onClose={(e) => {
        e.preventDefault();
      }}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
        <StyledMainBox component="main">
          <Box height={20} />
          <FormControl>
            <StyledStack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap">
              {selectionOptions.length !== 0 &&
                selectionOptions.map((option) => {
                  return (
                    <ConditionalOutlinedButton
                      key={option.value}
                      selected={selectedOption === option.value ? true : false}
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedOption(option.value);
                      }}
                      label={option.label}
                    />
                  );
                })}
            </StyledStack>
          </FormControl>
        </StyledMainBox>
      </DialogContent>
      <Box height={20} />
      <DialogActions>
        <StyledStack direction={"row"} spacing={2}>
          {showCancel === true && <CloseButton onClick={onCancel} label="Cancel" icon={<Close />} />}

          {/* disabled styling comes from DarkRedActionButton .Mui-disabled (muted grey) */}
          <ActionButton
            onClick={(e) => {
              e.preventDefault();
              const selectedAccessOption = selectionOptions.find((option) => option.value === selectedOption);
              if (typeof selectedAccessOption !== "undefined") {
                onEnter(selectedAccessOption);
              }
            }}
            disabled={selectedOption === ""}
            label={"Enter"}
            icon={<Save />}
          />
        </StyledStack>
      </DialogActions>
    </Dialog>
  );
};

export default AccessSelection;
